<template><div><h1>VUX V2.3.8 released</h1>
<h2><a href="/en/components/checker.html">Checker</a></h2>
<ul><li>[enhance] clear value when selected item is disabled #1479</li>
</ul>
<h2><a href="/en/components/checklist.html">Checklist</a></h2>
<ul><li>[feature] Add prop:disabled #1254</li>
</ul>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[enhance] prevent from clicking invisiable date #1564</li>
</ul>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] Fix placeholder missing on iOS9 and iOS8 #1293</li>
</ul>
<h2><a href="/en/components/radio.html">Radio</a></h2>
<ul><li>[feature] Add prop:disabled #1254</li>
<li>[feature] Add less:@radio-checked-icon-color #896</li>
</ul>
<h2><a href="/en/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] Add slot:title #1389</li>
</ul>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] new plugin</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.3.8 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.3.8-108.vue?40696474